import PocketBase from "pocketbase";
import { POCKETBASE_URL } from "../config/pocketbase";

export const PB_URL = import.meta.env.VITE_POCKETBASE_URL || POCKETBASE_URL;
console.log("[PocketBase] URL =", PB_URL);

export const pb = new PocketBase(PB_URL);
export const pbPublic = new PocketBase(PB_URL);

export interface UserRecord {
    id: string;
    email: string;
    name?: string;
    username?: string;
    avatar?: string;
    created: string;
    updated: string;
}

export interface PlanRecord {
    id: string;
    userId: string;
    userName?: string;
    planData: string | any;
    isPublic: boolean;
    isReadOnly: boolean;
    collaborators?: string[];
    lastEditedById?: string;
    lastEditedByName?: string;
    lastEditedAt?: string;
    created: string;
    updated: string;
}

export interface ImageRecord {
    id: string;
    userId: string;
    plan: string; // relation -> plans
    image: string;
    created: string;
    updated?: string;
    collectionId?: string;
    collectionName?: string;
}

export function buildFileUrl(record: any, filename: string, token?: string) {
    const collectionId = record.collectionId || record.collectionName;
    const url = new URL(`${PB_URL}/api/files/${collectionId}/${record.id}/${filename}`);
    if (token) url.searchParams.set("token", token);
    return url.toString();
}

export function getCurrentUserModel(): UserRecord | null {
    return (pb.authStore.model as any) ?? null;
}

export function isAuthenticated(): boolean {
    return pb.authStore.isValid && !!pb.authStore.model?.id;
}